import PartyTarget from "../../../model/character/PartyTarget";
import Damage from "../../../model/crew/Damage";
import Values from "../../../model/value/Values";
import Page from "../../framework/Page";
import ParentView from "../../framework/ParentView";
import MineDamageView from "./damage/MineDamageView";

export default class RowContainerDamage extends ParentView {
    /**
     * @param {string} parentId
     * @param {string} elementId
     * @param {Damage} damage
     * @param {Values} values
     * @param {PartyTarget} partyTarget
     */
    constructor(parentId, elementId, damage, values, partyTarget) {
        super(parentId, elementId);

        this.addView(new MineDamageView(elementId, damage, values, partyTarget));
    }

    /**
     * @override
     */
    initializeView() {
  
        const parentElement = Page.getElement(this.parentId);
        Page.createElement('div', parentElement, this.getElementId(), 'bottom-row-damage');

        super.initializeView();        
    }
}